<template>
  <div class="course-box">
    <div class="course-row" v-for="(el, eIndex) in courseList" :key="eIndex">
      <div
        class="course-item"
        v-for="(item, index) in el"
        :key="index"
        @click="goDetail(item)"
      >
        <img class="course-cover-img" :src="item.img" alt="封面" />
        <div class="course-title">
          {{ item.title
          }}
          <!-- <img
            src="https://qnunion.feierlaiedu.com/kcschool/cLUltbKi8F3UEvSUVndMkZeHs1jY0mTs"
            alt="封面"
          /> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useRouter } from "vue-router";
//课程列表
import course01 from "@/assets/home_image/course/mulu3.png";
import course02 from "@/assets/home_image/course/mulu4.png";
import course03 from "@/assets/home_image/course/mulu5.png";
import course04 from "@/assets/home_image/course/mulu6.png";
//课程列表
const courseList = [
  [
    {
      id: 1,
      title: "什么是儿童音乐剧",
      img: course01,
      link: "",
      show: true,
    },
    {
      id: 2,
      title: "你可以得到什么",
      img: course02,
      link: "",
      show: true,
    },
    {
      id: 3,
      title: "为什么选择我们",
      img: course03,
      link: "",
      show: true,
    },
  ],
  [
    {
      id: 4,
      title: "课程介绍",
      img: course04,
      link: "",
      show: true,
    },
  ],
];
const router = useRouter();

//跳转详情页
const goDetail = (item) => {
  if (item.show) {
    router.push(`/musicalIntroductionDetail?id=${item.id}`);
    window.onScroll = null;
  }
};
</script>
<style lang="scss" scoped>
.course-box {
  width: 1020px;
  height: auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 40px auto 60px;
  padding: 44px 54px 12px 54px;
  box-sizing: border-box;
  // background-color: #fff;
  .course-row {
    display: flex;
    // justify-content: space-between;
    align-items: center;
    width: 100%;
    .course-item:nth-child(1) {
      margin-left: 0;
    }
  }
  .course-item {
    width: 278px;
    height: 198px;
    display: inline-block;
    margin-left: 40px;
    margin-bottom: 32px;
    cursor: pointer;
    .course-cover-img {
      width: 278px;
      height: 144px;
      margin-bottom: 0;
    }
    .course-title {
      width: 278px;
      height: 54px;
      line-height: 54px;
      color: #222;
      font-weight: 900;
      display: flex;
      text-align: center;
      align-items: center;
      font-size: 16px;
      margin-right: 5px;
      justify-content: center;
      background: linear-gradient(180deg, #eff2f6 0%, #f7f9fb 100%);
      margin-top: -4px;
      img {
        margin-left: 6px;
      }
    }
  }
}
</style>
